var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFreindsLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 4C4.785 4 4 3.215 4 2.25C4 1.285 4.785 0.5 5.75 0.5C6.715 0.5 7.5 1.285 7.5 2.25C7.5 3.215 6.715 4 5.75 4ZM5.75 1C5.061 1 4.5 1.561 4.5 2.25C4.5 2.939 5.061 3.5 5.75 3.5C6.439 3.5 7 2.939 7 2.25C7 1.561 6.439 1 5.75 1Z",
    fill: "#26C6DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 5C8.561 5 8 4.439 8 3.75C8 3.061 8.561 2.5 9.25 2.5C9.939 2.5 10.5 3.061 10.5 3.75C10.5 4.439 9.939 5 9.25 5ZM9.25 3C8.8365 3 8.5 3.3365 8.5 3.75C8.5 4.1635 8.8365 4.5 9.25 4.5C9.6635 4.5 10 4.1635 10 3.75C10 3.3365 9.6635 3 9.25 3Z",
    fill: "#26C6DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2854 5C1.5964 5 1.0354 4.439 1.0354 3.75C1.0354 3.061 1.5959 2.5 2.2854 2.5C2.9749 2.5 3.5354 3.061 3.5354 3.75C3.5354 4.439 2.9744 5 2.2854 5ZM2.2854 3C1.8719 3 1.5354 3.3365 1.5354 3.75C1.5354 4.1635 1.8719 4.5 2.2854 4.5C2.6989 4.5 3.0354 4.1635 3.0354 3.75C3.0354 3.3365 2.6989 3 2.2854 3Z",
    fill: "#26C6DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 8C8.612 8 8.5 7.888 8.5 7.75C8.5 6.2335 7.2665 5 5.75 5C4.2335 5 3 6.2335 3 7.75C3 7.888 2.888 8 2.75 8C2.612 8 2.5 7.888 2.5 7.75C2.5 5.958 3.958 4.5 5.75 4.5C7.542 4.5 9 5.958 9 7.75C9 7.888 8.888 8 8.75 8Z",
    fill: "#26C6DA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8C11.112 8 11 7.888 11 7.75C11 6.785 10.215 6 9.24999 6C8.92949 6 8.61649 6.087 8.34399 6.2525C8.22599 6.324 8.07299 6.2865 8.00049 6.1685C7.92899 6.0505 7.96699 5.897 8.08449 5.825C8.43549 5.6125 8.83849 5.5 9.24999 5.5C10.4905 5.5 11.5 6.5095 11.5 7.75C11.5 7.888 11.388 8 11.25 8Z",
    fill: "#26C6DA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 8C0.112 8 0 7.888 0 7.75C0 6.5095 1.0095 5.5 2.25 5.5C2.6615 5.5 3.0645 5.6125 3.415 5.8245C3.533 5.8965 3.571 6.05 3.499 6.168C3.427 6.286 3.273 6.3235 3.1555 6.252C2.8835 6.087 2.5705 6 2.25 6C1.285 6 0.5 6.785 0.5 7.75C0.5 7.888 0.388 8 0.25 8Z",
    fill: "#26C6DA"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFreindsLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/freindsLogo.8e1b9ceb.svg";
export { ForwardRef as ReactComponent };